export default __webpack_public_path__ + "static/media/rewards.971732a0.svg";